export const signUpSource = Object.freeze({
  CLINICIAN_WEB_QUICK_ENROLL: 'clinician_web_quick_enroll',
  CLINICIAN_WEB_FULL_ENROLL: 'clinician_web_full_enroll',
  CLINICIAN_WEB_ENROLL: 'clinician_web_enroll'
})
